import {Component, ViewChild, OnInit} from '@angular/core';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import * as firebase from 'firebase';

@Component({
  selector: 'app-adminextraescolares',
  templateUrl: './adminextraescolares.component.html',
  styleUrls: ['./adminextraescolares.component.scss']
})
export class AdminextraescolaresComponent implements OnInit {
  user;
  userId = '';
  ampa;

  // datos de la tabla
  displayedColumns = ['select','imagen', 'nombre',  'descripcion', 'nivel', 'telefono',  'email', 'empresa', 'precio', 'acciones'];

  selection = new SelectionModel<ExtraescolaresData>(true, []);
  dataSource: MatTableDataSource<ExtraescolaresData>;
  extraescolares: ExtraescolaresData[] = [];
  initialSelection = [];
  allowMultiSelect = true;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor( private router: Router ) {
    console.log('constructor')
    /* COMENTARIO DE JOSE MIGUEL. Falta crear un servicio que busque y compruebe los datos del ampa
    deberiamos hacerlo como un provider que haga la llamada al ws y hacerlo
    funcionar como un guard para todas las rutas. Aparte habría que complementarlo
    con autentificación de usuarios*/
  }

   ngOnInit() {

     console.log('ngoninit')
     this.dataSource = new MatTableDataSource(this.extraescolares);
     this.dataSource.paginator = this.paginator;
     this.dataSource.sort = this.sort;
     //obtener datos del usuario admin logueado
     this.userId = localStorage.getItem('userId');
     console.log('UserId', this.userId);
     if(!this.userId){
       this.router.navigate[('')]
     } else {
       firebase.firestore().collection('admins').doc(this.userId)
       .get()
       .then((doc)=>{
         this.user = doc.data();
         console.log('User', this.user)

         this.obtenerExtraescolares();
       })
     }
  }

  // nos traemos los extraescolares del ampa utilizando el id de ampa que tiene el usuario en su documento
  obtenerExtraescolares(){
    console.log('obtenerExtraescolares')
    firebase.firestore().collection('extraescolares')
    .where('ampa','==', this.user.ampa)
    .get()
    .then((snapshot)=>{

      snapshot.forEach((doc)=>{
        console.log('doc',doc)
        //var elemento: ExtraescolaresData;
        var elemento = doc.data();
        elemento.id = doc.id;
        //hacemos el push
        this.extraescolares = [...this.extraescolares, <ExtraescolaresData>elemento];
      })
      this.dataSource = new MatTableDataSource(this.extraescolares);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    })
  }



  // mostramos los datos del extraescolar id
  ver(row){
    console.log('Ver ', row.id);
    this.router.navigate(['/admin/extraescolares/ver/' + row.id]);
  }

  // eliminar extraescolares seleccionados
  eliminar(){
      this.selection.selected.forEach((extraescolar) => {
        firebase.firestore().collection('extraescolares').doc(extraescolar.id)
        .delete()
        .catch(error => {console.log(error); })
        .then(()=>{
          console.log('Borrada extraescolar ' + extraescolar.id)
        })
      });
      this.extraescolares = [];
      this.obtenerExtraescolares();
  }

  // actualizamos los datos de algunos campos del extraescolar id
  editar(row){
    console.log('Editado ', row.id)
    this.router.navigate(['/admin/extraescolares/editar/' + row.id])
  }

  //exportamos a xlsx datos de extraescolares seleccionados
  exportToExcel() {
    var ws = XLSX.utils.json_to_sheet(this.selection.selected);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Extraescolares");
    XLSX.writeFile(wb, 'extraescolares.xlsx');
  }

  exportToPDF() {

  }


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected == numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
    this.selection.clear() :
    this.dataSource.data.forEach(row => this.selection.select(row));
  }
}

export interface ExtraescolaresData {
  id: string;
  imagen: string;
  nombre: string;
  descripcion: string;
  nivel: string;
  telefono: string;
  email: string;
  empresa: string;
  precio: string;
  }



// WEBPACK FOOTER //
// ./src/app/adminextraescolares/adminextraescolares.component.ts